module.exports = __webpack_public_path__ + "img/23rdandhare_thumbnail.2c4ab10a.png";